import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation, type UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {riskSurveyMutations} from '../../api'
import {useRiskSurveyTranslation} from '../useRiskSurveyTranslation'

import {riskSurveyQueryKeys} from './riskSurveyQueryKeys'

type Variables = {
  reportId: string
  linkId: string
}

export const useDeleteReportLink = (options?: UseMutationOptions<void, AxiosError, Variables>) => {
  const {t} = useRiskSurveyTranslation()
  const queryClient = useQueryClient()

  return useMutation<void, AxiosError, Variables>({
    mutationFn: ({reportId, linkId}) => riskSurveyMutations.deleteReportLink(reportId, linkId),
    ...options,
    onSuccess: (data, variables, onMutateResult, context) => {
      spawnSuccessToast(t('links.deleteSuccess'))
      void options?.onSuccess?.(data, variables, onMutateResult, context)
    },
    onError: (error, variables, onMutateResult, context) => {
      spawnErrorToast(t('links.deleteError'))
      void options?.onError?.(error, variables, onMutateResult, context)
    },
    onSettled: (data, error, variables, onMutateResult, context) => {
      void queryClient.invalidateQueries({queryKey: riskSurveyQueryKeys.reports.lists()})
      void queryClient.invalidateQueries({
        queryKey: riskSurveyQueryKeys.reports.detail(variables.reportId)
      })
      void queryClient.invalidateQueries({
        queryKey: riskSurveyQueryKeys.reports.links(variables.reportId)
      })
      void options?.onSettled?.(data, error, variables, onMutateResult, context)
    }
  })
}
